import { useTranslation } from 'react-i18next';
import { GameStaticCategories } from '@/helpers/game';
import { oneRowSliderParams } from '@/helpers/games';
import LobbyGamesSlider from '@/modules/lobby/components/LobbyGamesSlider';
import { useGetCommonStore } from '@/store';
import { ImageComponent } from '../Image';

export const RecentGames = () => {
  const { t } = useTranslation('common');
  const useCommonStore = useGetCommonStore();

  const recentGames = useCommonStore.use.recentGames();

  if (!recentGames.length) return null;

  return (
    <LobbyGamesSlider
      categoryId={GameStaticCategories.Recent}
      gamesList={recentGames}
      sliderParams={oneRowSliderParams}
      title={t(`common:gameCategories:${GameStaticCategories.Recent}`)}
      titleIcon={
        <ImageComponent alt="icon" height={24} src="/clock.webp" width={24} />
      }
    />
  );
};
